import EncryptedStorage from 'react-native-encrypted-storage';
import { Platform } from 'react-native';

const KEY = 'svyaz_ui_locale';
const LEGACY_KEY = 'vr_ui_locale';

function isWeb(): boolean {
  return Platform.OS === 'web';
}

export async function readSavedLocale(): Promise<string | null> {
  if (isWeb()) {
    try {
      if (typeof globalThis.localStorage === 'undefined') return null;
      const v = globalThis.localStorage.getItem(KEY);
      if (v) return v;
      const legacy = globalThis.localStorage.getItem(LEGACY_KEY);
      if (legacy) {
        globalThis.localStorage.setItem(KEY, legacy);
        globalThis.localStorage.removeItem(LEGACY_KEY);
      }
      return legacy;
    } catch {
      return null;
    }
  }
  try {
    const v = await EncryptedStorage.getItem(KEY);
    if (v) return v;
    const legacy = await EncryptedStorage.getItem(LEGACY_KEY);
    if (legacy) {
      await EncryptedStorage.setItem(KEY, legacy);
      await EncryptedStorage.removeItem(LEGACY_KEY);
    }
    return legacy;
  } catch {
    return null;
  }
}

export async function writeSavedLocale(value: string): Promise<void> {
  if (isWeb()) {
    try {
      globalThis.localStorage?.setItem(KEY, value);
    } catch {
      /* noop */
    }
    return;
  }
  try {
    await EncryptedStorage.setItem(KEY, value);
  } catch {
    /* noop */
  }
}
